'use strict';

function getRegNonCapturing(src, opt) {
  if (src.length > 1) {
    src = '(?:' + src + ')';
  }
  if (opt) {
    src += '?';
  }
  return src;
}

module.exports = getRegNonCapturing;


// WEBPACK FOOTER //
// ./~/sugar-date/date/internal/getRegNonCapturing.js